(function () {
  var copy = {
    en: {
      button: 'Size Guide',
      title: 'Size Chart - Brace',
      columns: { us: 'US SIZE', uk: 'UK SIZE', eu: 'EU SIZE', au: 'AU SIZE' },
      caption: "If the size you order doesn't fit perfectly, don't worry! We offer a 30-day window for easy exchanges."
    },
    nl: {
      button: 'Maattabel',
      title: 'Maattabel - Brace',
      columns: { us: 'US MAAT', uk: 'UK MAAT', eu: 'EU MAAT', au: 'AU MAAT' },
      caption: 'Als de maat die je bestelt niet perfect past, geen zorgen! We bieden een periode van 30 dagen voor eenvoudig omruilen.'
    },
    de: {
      button: 'Größentabelle',
      title: 'Größentabelle - Orthese',
      columns: { us: 'US-GRÖSSE', uk: 'UK-GRÖSSE', eu: 'EU-GRÖSSE', au: 'AU-GRÖSSE' },
      caption: 'Falls die bestellte Größe nicht perfekt passt, kein Problem! Wir bieten dir 30 Tage Zeit für einen einfachen Umtausch.'
    },
    fr: {
      button: 'Guide des tailles',
      title: 'Guide des tailles - Attelle',
      columns: { us: 'POINTURE US', uk: 'POINTURE UK', eu: 'POINTURE EU', au: 'POINTURE AU' },
      caption: "Si la taille commandée ne vous va pas parfaitement, ne vous inquiétez pas ! Nous offrons un délai de 30 jours pour un échange facile."
    }
  };

  var tabs = ['us', 'uk', 'eu', 'au'];
  var rows = {
    us: [['S', '4–6'], ['M', '7–9'], ['L', '10–12'], ['XL', '13+']],
    uk: [['S', '2–4'], ['M', '5–7'], ['L', '8–10'], ['XL', '11+']],
    eu: [['S', '35–37'], ['M', '38–41'], ['L', '42–44'], ['XL', '45+']],
    au: [['S', '2–4'], ['M', '5–7'], ['L', '8–10'], ['XL', '11+']]
  };

  function getLang() {
    var lang = (document.documentElement.lang || 'en').toLowerCase().slice(0, 2);
    return copy[lang] ? lang : 'en';
  }

  function text() { return copy[getLang()]; }
  function defaultTab() { return 'eu'; }

  function firstHeader(strings) {
    var lang = getLang();
    if (lang === 'nl') return 'MAAT';
    if (lang === 'de') return 'GRÖSSE';
    if (lang === 'fr') return 'TAILLE';
    return 'SIZE';
  }

  function buildTable(tab, strings) {
    var body = rows[tab].map(function (row) {
      return '<tr><td>' + row[0] + '</td><td>' + row[1] + '</td></tr>';
    }).join('');
    return '<div class="bg-size-guide-modal__table-wrap"><table><thead><tr><th scope="col">' + firstHeader(strings) + '</th><th scope="col">' + strings.columns[tab] + '</th></tr></thead><tbody>' + body + '</tbody></table></div>';
  }

  function updateContent(modal, tab) {
    var strings = text();
    modal.querySelectorAll('[data-bg-size-tab]').forEach(function (el) {
      var active = el.getAttribute('data-bg-size-tab') === tab;
      el.setAttribute('aria-selected', active ? 'true' : 'false');
      el.tabIndex = active ? 0 : -1;
    });
    modal.querySelector('[data-bg-size-table]').innerHTML = buildTable(tab, strings);
    modal.querySelector('[data-bg-size-caption]').textContent = strings.caption;
    modal.setAttribute('data-active-tab', tab);
  }

  function ensureModal() {
    var existing = document.getElementById('BgSizeGuideModal');
    if (existing) {
      updateContent(existing, existing.getAttribute('data-active-tab') || defaultTab());
      return existing;
    }

    var strings = text();
    var dialog = document.createElement('dialog');
    dialog.id = 'BgSizeGuideModal';
    dialog.className = 'bg-size-guide-modal';
    dialog.setAttribute('aria-labelledby', 'BgSizeGuideTitle');
    dialog.setAttribute('data-active-tab', defaultTab());
    dialog.innerHTML = '<div class="bg-size-guide-modal__inner">' +
      '<button class="bg-size-guide-modal__close" type="button" aria-label="Close">×</button>' +
      '<h2 class="bg-size-guide-modal__title" id="BgSizeGuideTitle">' + strings.title + '</h2>' +
      '<div class="bg-size-guide-modal__divider"></div>' +
      '<div class="bg-size-guide-modal__tabs" role="tablist" aria-label="Size regions">' +
      tabs.map(function (tab) {
        var selected = tab === defaultTab();
        return '<button type="button" class="bg-size-guide-modal__tab" role="tab" data-bg-size-tab="' + tab + '" aria-selected="' + (selected ? 'true' : 'false') + '" tabindex="' + (selected ? '0' : '-1') + '">' + tab.toUpperCase() + '</button>';
      }).join('') +
      '</div>' +
      '<div data-bg-size-table></div>' +
      '<p class="bg-size-guide-modal__caption" data-bg-size-caption></p>' +
      '</div>';

    document.body.appendChild(dialog);
    dialog.querySelector('.bg-size-guide-modal__close').addEventListener('click', function () { dialog.close(); });
    dialog.addEventListener('click', function (event) {
      var rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
    });
    dialog.querySelectorAll('[data-bg-size-tab]').forEach(function (button) {
      button.addEventListener('click', function () { updateContent(dialog, button.getAttribute('data-bg-size-tab')); });
    });
    updateContent(dialog, defaultTab());
    return dialog;
  }

  function findInventory() {
    var scope = document.querySelector('.product__info-container') || document.querySelector('.product__info-wrapper') || document;
    return scope.querySelector('[id^="Inventory-"]') || scope.querySelector('.product__inventory');
  }

  function mount() {
    if (document.querySelector('[data-bg-size-guide]')) return;
    var inventory = findInventory();
    if (!inventory) return;
    var strings = text();
    var wrap = document.createElement('div');
    wrap.className = 'bg-size-guide';
    wrap.setAttribute('data-bg-size-guide', '');
    wrap.innerHTML = '<button class="bg-size-guide__trigger" type="button" aria-haspopup="dialog" aria-controls="BgSizeGuideModal"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 17.5 17.5 4l2.5 2.5L6.5 20 4 17.5Z"/><path d="m14.5 7 2.5 2.5M12 9.5l1.8 1.8M9.5 12l2.5 2.5M7 14.5l1.8 1.8"/></svg><span>' + strings.button + '</span></button>';
    var anchor = inventory.closest('.product__inventory') || inventory;
    if (anchor.parentNode) anchor.parentNode.insertBefore(wrap, anchor);
    wrap.querySelector('button').addEventListener('click', function (event) {
      event.preventDefault();
      var dialog = ensureModal();
      if (dialog.open) return;
      if (typeof dialog.showModal === 'function') {
        try { dialog.showModal(); }
        catch (error) { dialog.setAttribute('open', ''); }
      } else {
        dialog.setAttribute('open', '');
      }
    });
  }

  function init() {
    mount();
    var observer = new MutationObserver(function () { mount(); });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function () { setTimeout(mount, 0); });
})();
